import { Snackbar, Alert } from '@mui/material';
import { useSnackbarStore } from '../../stores/snackbarStore';

/**
 * Global app snackbar for success/error/info/warning notifications.
 *
 * Trigger from anywhere using snackbarStore:
 * ```ts
 * const { showSnackbar } = useSnackbarStore();
 * showSnackbar('Saved successfully');
 * showSnackbar('Something went wrong', 'error');
 * ```
 *
 * Mount once in App.tsx.
 */
export function AppSnackbar() {
  const { open, message, severity, autoHideDuration, hideSnackbar } =
    useSnackbarStore();

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={hideSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity={severity}
        variant="filled"
        onClose={hideSnackbar}
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
